module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clum2left left"
  }, [_c('div', {
    attrs: {
      "id": "account_block"
    }
  }, [_c('div', {
    attrs: {
      "id": "account_title"
    }
  }, [_vm._v("My Account")]), _vm._v(" "), _c('div', {
    staticClass: "myaccountlist"
  }, [_c('ul', {
    staticClass: "myaccountlist"
  }, [_c('li', {
    class: {
      current: _vm.isProfileActive
    },
    on: {
      "click": function($event) {
        _vm.clickProfile()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("My Profile")])]), _vm._v(" "), _c('li', {
    class: {
      current: _vm.isMapsActive
    },
    on: {
      "click": function($event) {
        _vm.clickMaps()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Maps & Update")])]), _vm._v(" "), _c('li', [_vm._m(2), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.clicklogout()
      }
    }
  }, [_vm._v("Logout")])])])])]), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myaccounticon left"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/acc_icon_01.png"),
      "width": "38",
      "height": "38",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myaccounticon left"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/acc_icon_02.png"),
      "width": "38",
      "height": "38",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myaccounticon left"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/acc_icon_03.png"),
      "width": "38",
      "height": "38",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "update_block"
    }
  }, [_c('div', {
    attrs: {
      "id": "update_content"
    }
  }, [_c('div', {
    staticClass: "update_title"
  }, [_vm._v("Map Updater 3")]), _vm._v(" "), _c('div', {
    staticClass: "update_img"
  }), _vm._v(" "), _c('div', [_c('form', {
    attrs: {
      "method": "get",
      "action": "http://maptool.polnav.com.tw/fixture/Flash/MapUpdater3/mapupdater3_setup.exe"
    }
  }, [_c('button', {
    staticClass: "button-warning pure-button login_input"
  }, [_vm._v("Download")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9790f7e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/private/layout/Aside.vue
// module id = 116
// module chunks = 1